import React from 'react';
import { Suspense } from 'react';
import './App.css';
import { Routes, Route } from "react-router-dom";
import { Header } from './components/Header';
import Sections from './components/sections';
import { createTheme, ThemeProvider, } from '@mui/material/styles';
import { green } from '@mui/material/colors';
import { pageData } from './components/text/pageText';
import { sectionData } from './components/text/sectionText';

// import VTabs from './components/structure/vTabs';
// import { Main } from './components/Main';
// import Footer from './components/Footer';
// import Page from './components/structure/page';

// import bg1 from './components/img/bg1.webp';
// import bg2 from './components/img/bg2b.webp';
// import bg3 from './components/img/bg3b.webp';
// import bg6 from './components/img/bg6.webp';
// import bg7 from './components/img/bg7.webp';
// import bg8 from './components/img/bg8.webp';
// import bg9 from './components/img/bg9.webp';

const LazyPage = React.lazy(() => import('./components/structure/page'));
const LazyFooter = React.lazy(() => import('./components/Footer'));
const LazyPortfolio = React.lazy(() => import('./components/structure/portfolio'));

const theme = createTheme({
  palette: {
    primary: {
      main: '#2346A0',
      dark: '#155475'
    },
    secondary: {
      main: '#7ab340',
      dark: green[900]
    },
  },
  components: {
      /*MuiTabs: {
          styleOverrides: {
            scroller: { backgroundColor: 'transparent', display: 'flex', alignItems: 'center', },
          },
      },*/
      // MuiTooltip: {
      //     styleOverrides: {
      //         tooltip: { color: "#ffffff", backgroundColor: "#7ab340", fontSize: "1em", },
      //         arrow: { color: "#7ab340", },
      //      }
      // },
      // MuiFormControl: {
      //   styleOverrides: {
      //     root: { marginTop:'3px', marginBottom:'3px'}
      //   }
      // }
  },
});

// const pathName = parseInt(window.location.pathname.slice(1));

function App() {
  // const { tab } = useParams();
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
          <Header />
          <Routes>
            <Route path="/"             element={<Sections />} />
            {/*<Route path="/:active_tab"  element={<VTabs active={pathName ? pathName : 0} />} />*/}

            <Route path="company"       element={  <Suspense fallback={null}>
                                                      <LazyPage txtMain={pageData[0].main} bg={process.env.PUBLIC_URL + '/img/bg1.webp'} title={`Ποιοι είμαστε`} 
                                                                form={'none'} back={''} color={'#fff'}
                                                                p1={pageData[0].p1} p2={pageData[0].p2} p3={pageData[0].p3}
                                                                p4={pageData[0].p4} p5={pageData[0].p5} p6={pageData[0].p6}
                                                      />
                                                  </Suspense>
                                        }
            />
            <Route path="net-billing"  element={
                                                  <Suspense fallback={null}>
                                                      <LazyPage txtMain={pageData[1].main} bg={process.env.PUBLIC_URL + '/img/bg2b.webp'} title={`net-billing`}
                                                                form={'none'} back={'#Net-billing'} topPos={'12%'}
                                                                p1={pageData[1].p1} p2={pageData[1].p2} p3={pageData[1].p3} p4={pageData[1].p4} p5={pageData[1].p5}
                                                                color={theme.palette.secondary.main} p8dis={'none'}
                                                      />
                                                  </Suspense>
                                        }
            />
            <Route path="saving"        element={ <Suspense fallback={null}>
                                                      <LazyPage txtMain={pageData[2].main} bg={process.env.PUBLIC_URL + '/img/bg3b.webp'} title={`Πόσο κερδίζετε;`}
                                                                form={'block'} back={'#Saving'} topPos={'70%'} color={theme.palette.primary.main}
                                                                p1={pageData[2].p1} p2={pageData[2].p2} p3={pageData[2].p3} p4={pageData[2].p4}
                                                                p5={pageData[2].p5} p6={pageData[2].p6} p7={pageData[2].p7} p8={pageData[2].p8}
                                                      />
                                                  </Suspense>
                                        }
            />
            <Route path="process"       element={ <Suspense fallback={null}>
                                                      <LazyPage txtMain={pageData[3].main} bg={process.env.PUBLIC_URL + '/img/bg6.webp'} title={`H διαδικασία`} 
                                                                form={'block'} back={'#Process'}  color={'#fff'}
                                                                p1={pageData[3].p1} p2={pageData[3].p2} p3={pageData[3].p3}
                                                                p3dis={'none'} p4dis={'none'} p5dis={'none'} p6dis={'none'} p7dis={'none'} p8dis={'none'}
                                                      />
                                                  </Suspense>
                                        }
            />
            <Route path="StandAlone-PV" element={ <Suspense fallback={null}>
                                                      <LazyPage txtMain={sectionData[6].mainText} bg={process.env.PUBLIC_URL + '/img/bg7.webp'} title={sectionData[6].head}
                                                                form={'none'} back={''} color={'#fff'} topPos={'50%'}
                                                                p1={sectionData[6].mainText} p2={''} p3={''} p4={``}
                                                                p5dis={'none'} p6dis={'none'} p7dis={'none'} p8dis={'none'}
                                                      />
                                                  </Suspense>
                                        }
            />
            <Route path="PV-Park"       element={ <Suspense fallback={null}>
                                                      <LazyPage txtMain={sectionData[7].mainText} bg={process.env.PUBLIC_URL + '/img/bg8.webp'} title={sectionData[7].head}
                                                                form={'none'} back={''} color={'#fff'}
                                                                p1={sectionData[7].mainText} p2={''} p3={''} p4={``}
                                                                p5dis={'none'} p6dis={'none'} p7dis={'none'} p8dis={'none'}
                                                      />
                                                  </Suspense>
                                        }
            />
            <Route path="Services"      element={ <Suspense fallback={null}>
                                                      <LazyPage txtMain={sectionData[8].mainText} bg={process.env.PUBLIC_URL + '/img/bg9.webp'} title={sectionData[8].head}
                                                                form={'none'} back={''} color={'#fff'}
                                                                p1={sectionData[8].mainText} p2={''} p3={''} p4={``}
                                                                p5dis={'none'} p6dis={'none'} p7dis={'none'} p8dis={'none'}
                                                      />
                                                  </Suspense>
                                        }
            />
            <Route path="Contact" element={ <Suspense fallback={null}>
                                              <LazyFooter />
                                            </Suspense>
                                          } 
            />
            <Route path="Projects"      element={ <Suspense fallback={null}>
                                                      <LazyPortfolio title={`Τα έργα μας`} color={theme.palette.primary.main}
                                                                     back={''}
                                                      />
                                                  </Suspense>
                                        }
            />
          </Routes>
      </ThemeProvider>
    </div>
  );
}

export default App;
